<template>
  <div class="product-template __donate">

    <h1 data-v-1f20e9ef="" class="page-title text-center">บริจาค</h1>
    <h3 data-v-fe7e2e22="" class="page-title text-center">เพื่อให้โอกาสทางการศึกษา</h3>

    <div class="container pd-sm-0 mt-3">
      <div class="col-md-push-2 col-md-10 col-lg-push-2 col-md-8">
        <div class="product product--inline">
          <div class="product__block--form">
            <div class="radius block shadow">
              <product-donate-choice
              :show-donate-type="true"
              :product="product"
              v-model="product.price"
              ref="donateChoice"
              classes="col-1-5" />

              <donor-info
                v-model="attributes.info" />

              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false" />

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction" />

              <div class="text-center">
                <button type="button" class="btn btn--purple btn--default" @click.prevent="donate">บริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'

  export default {
    name: 'ProductDonateTemplate',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    data () {
      return {
        attributes: {}
      }
    },

    methods: {
      donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }

        this.$store.dispatch('clearCart').then(() => {
          this.$refs.cartAction.buyNow()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  h1.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    font-size: 2em;
    font-weight: 400;
    margin-bottom: 15px;
  }

  h3.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  }
  .block { background: #fff; }
  .btn--default {
    margin: 20px auto 10px;
  }
</style>



// WEBPACK FOOTER //
// donate.vue?33029125